module.exports = __webpack_public_path__ + "static/media/close.d7412649.svg";